import {
  get, post, put, delete_, patch,
} from '@app/utilities/fetchWrapper';
import type { Map } from '@app/premiumFeatures/maps/map';

async function postMapImage(url: string, imageFile: File): Promise<void> {
  const data = new FormData();
  data.append('image', imageFile, imageFile.name);
  await post(
    url,
    {
      body: data,
      headers: undefined,
    },
  );
}

export default {
  get: async function(galleryItemId: string): Promise<Map> {
    return get(`${COW_API_URL}/maps/gallery_items/${galleryItemId}/map`);
  },
  addEntityMap: function(entityId: string, imageFile: File): Promise<void> {
    return postMapImage(`${COW_API_URL}/maps/entities/${entityId}`, imageFile);
  },
  addUniverseMap: function(universeId: string, imageFile: File): Promise<void> {
    return postMapImage(`${COW_API_URL}/maps/universes/${universeId}`, imageFile);
  },
  addEntityMapByUrl: async function(entityId: string, url: string): Promise<void> {
    await post(
      `${COW_API_URL}/maps/entities/${entityId}/by_url`,
      { body: JSON.stringify({ url }) },
    );
  },
  addUniverseMapByUrl: async function(universeId: string, url: string): Promise<void> {
    await post(
      `${COW_API_URL}/maps/universes/${universeId}/by_url`,
      { body: JSON.stringify({ url }) },
    );
  },
  deleteMap: async function(galleryItemId: string): Promise<void> {
    await delete_(`${COW_API_URL}/maps/gallery_items/${galleryItemId}/map`);
  },
  undoDeleteMap: async function(galleryItemId: string): Promise<void> {
    await patch(
      `${COW_API_URL}/maps/gallery_items/deleted/${galleryItemId}/map`,
      { body: JSON.stringify({}) },
    );
  },
  getEntityTypeMapSettings: async function(
    entityTypeId: string,
  ): Promise<{entityTypeId: string, mapsEnabled: boolean}> {
    try {
      return await get(`${COW_API_URL}/maps/entity_types/${entityTypeId}/settings`);
    }
    catch {
      return { entityTypeId, mapsEnabled: true };
    }
  },
  updateEntityTypeMapSettings: async function(
    entityTypeId: string,
    mapsEnabled: boolean,
  ): Promise<{entityTypeId: string, mapsEnabled: boolean}> {
    return put(
      `${COW_API_URL}/maps/entity_types/${entityTypeId}/settings`,
      { body: JSON.stringify({ mapsEnabled }) },
    );
  },
};
